module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_7016.7231884e.png";